import React from 'react';

interface WidgetStyles {
  chatBackgroundColor: string;
  chatBorderColor: string;
  chatBorderRadius: number;
  chatWidth: number;
  chatHeight: number;
  headerBackgroundColor: string;
  headerColor: string;
  botBackgroundColor: string;
  botColor: string;
  botAvatarBackgroundColor: string;
  botAvatarColor: string;
  botAvatarSize: number;
  sendButtonBackgroundColor: string;
  sendButtonColor: string;
  inputAreaBackgroundColor?: string;
  userBackgroundColor: string;
  userColor: string;
}

interface WidgetText {
  headerTitle: string;
  botMessage: string;
  inputPlaceholder: string;
  sendButtonText: string;
  emailInfoText: string;
}

interface ThatsUpWidgetProps {
  styles: WidgetStyles;
  textContent: WidgetText;
}

export function ThatsUpWidget({ styles, textContent }: ThatsUpWidgetProps) {
  return (
    <div 
      className="chatbot-container"
      style={{
        width: `${styles.chatWidth}px`,
        height: `${styles.chatHeight}px`,
        display: 'flex',
        flexDirection: 'column',
        boxShadow: '0 5px 20px rgba(0, 0, 0, 0.2)',
        border: `1px solid ${styles.chatBorderColor}`,
        borderRadius: `${styles.chatBorderRadius}px`,
        overflow: 'hidden'
      }}
    >
      <header className="chatbot-header" style={{
        backgroundColor: styles.headerBackgroundColor,
        color: styles.headerColor,
        padding: '12px 20px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        fontSize: '2rem',
        fontWeight: 500
      }}>
        <span>{textContent.headerTitle}</span>
        <button className="close-button" style={{
          background: 'none',
          border: 'none',
          color: styles.headerColor,
          fontSize: '2rem',
          fontWeight: 300,
          cursor: 'pointer',
          lineHeight: 1
        }} aria-label="Close chat">&times;</button>
      </header>
      
      <div className="chatbot-body" style={{
        backgroundColor: styles.chatBackgroundColor,
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column'
      }}>
        <div className="email-info" style={{
          padding: '16px',
          fontSize: '0.9rem',
          color: '#333',
          backgroundColor: '#f9f9f9',
          margin: '16px',
          borderRadius: '4px'
        }}>
          {textContent.emailInfoText}
        </div>
        
        <div className="chat-area" style={{
          flexGrow: 1,
          padding: '0 16px',
          display: 'flex',
          flexDirection: 'column'
        }}>
          <div className="message-container" style={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            maxWidth: '90%',
            position: 'relative'
          }}>
            <div className="avatar" style={{
              width: `${styles.botAvatarSize}px`,
              height: `${styles.botAvatarSize}px`,
              borderRadius: '50%',
              backgroundColor: styles.botAvatarBackgroundColor,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
              position: 'absolute',
              top: '0px' // Adjust this value to move avatar up/down
            }}>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 13c1.65 0 3-1.35 3-3S8.65 7 7 7s-3 1.35-3 3 1.35 3 3 3zm12-6h-8v7H3V5H1v15h2v-3h18v3h2v-9c0-2.21-1.79-4-4-4z" fill={styles.botAvatarColor} />
              </svg>
            </div>
            <div className="message-bubble" style={{
              backgroundColor: styles.botBackgroundColor,
              color: styles.botColor,
              padding: '12px 16px',
              borderRadius: '0 18px 18px 18px',
              fontSize: '1rem',
              marginTop: '15px', // Adjust this value to move bubble up/down
              position: 'relative',
              left: '45px' // Adjust this value to move bubble left/right
            }}>
              {textContent.botMessage}
            </div>
          </div>
          
          {/* User response message */}
          <div className="message-container" style={{
            display: 'flex',
            justifyContent: 'flex-end',
            maxWidth: '87%',
            marginTop: '16px',
            marginLeft: 'auto'
          }}>
            <div className="message-bubble" style={{
              backgroundColor: styles.userBackgroundColor,
              color: styles.userColor,
              padding: '12px 16px',
              borderRadius: '18px 18px 0px 18px',
              fontSize: '1rem'
            }}>
              Thanks! I have a question about check-in.
            </div>
          </div>
        </div>
      </div>
      
      <footer className="input-area" style={{
        display: 'flex',
        borderTop: '1px solid #e0e0e0',
        backgroundColor: styles.inputAreaBackgroundColor || 'transparent'
      }}>
        <input 
          type="text" 
          placeholder={textContent.inputPlaceholder}
          style={{
            flexGrow: 1,
            border: `1px solid ${styles.sendButtonBackgroundColor}`,
            padding: '18px 16px',
            fontSize: '1rem',
            outline: 'none'
          }}
        />
        <button style={{
          backgroundColor: styles.sendButtonBackgroundColor,
          color: styles.sendButtonColor,
          border: 'none',
          padding: '0 28px',
          fontSize: '1rem',
          fontWeight: 500,
          cursor: 'pointer'
        }}>{textContent.sendButtonText}</button>
      </footer>
    </div>
  );
}
